import Styled from 'styled-components'

export const Container = Styled.div`
  width: 100px;
  height: 100px;
  align-content: center;
`
